import React from "react";
import { DeploymentDetailsLegacy } from "./DeploymentDetailsLegacy";
import { DeploymentDetailsRegional } from "./DeploymentDetailsRegional";

export interface UpdateDeploymentProps {
  isUpdate?: boolean;
  deploymentId?: string;
  targetEndpoint?: string;
  deployedEndpoint?: string;
  timeout?: number;
  region?: string;
  targetRegion?: string;
  gatewayRegion?: string;
  refreshDeployments?: () => void;
  deploymentStatus?: string;
  serviceId?: string;
}

interface DeploymentDetailsProps {
  /** develop: API `location` for region/env badge when flag off */
  location?: string;
  targetRegion?: string;
  gatewayRegion?: string;
  targetEndpoint?: string;
  deployedEndpoint?: string;
  timeout?: string;
  deploymentStatus?: string;
  deploymentId?: string;
  serviceId: string;
  refreshDeployments?: () => void;
  onDeploymentUpdated?: () => void;
}

const supportRegionalDeployments =
  process.env.REACT_APP_SUPPORT_REGIONAL_DEPLOYMENTS === "true";

export const DeploymentDetails: React.FC<DeploymentDetailsProps> = (props) => {
  if (!supportRegionalDeployments) {
    return (
      <DeploymentDetailsLegacy
        region={
          props.location ??
          props.targetRegion ??
          props.gatewayRegion ??
          ""
        }
        targetEndpoint={props.targetEndpoint}
        deployedEndpoint={props.deployedEndpoint}
        timeout={props.timeout}
        deploymentStatus={props.deploymentStatus}
        deploymentId={props.deploymentId}
        serviceId={props.serviceId}
        refreshDeployments={props.refreshDeployments}
      />
    );
  }

  return (
    <DeploymentDetailsRegional
      targetRegion={props.targetRegion ?? props.location ?? ""}
      gatewayRegion={props.gatewayRegion ?? props.location ?? ""}
      targetEndpoint={props.targetEndpoint}
      deployedEndpoint={props.deployedEndpoint}
      timeout={props.timeout}
      deploymentStatus={props.deploymentStatus}
      deploymentId={props.deploymentId}
      serviceId={props.serviceId}
      refreshDeployments={props.refreshDeployments}
      onDeploymentUpdated={props.onDeploymentUpdated}
    />
  );
};
